import { useEffect, useRef } from 'react';

// Like useEffect with a dependencies array, but doesn't run on mount/unmount
const useDidUpdateEffect = (func: Function, deps: Array<any>) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  // eslint-disable-next-line
  }, deps);
};

export default useDidUpdateEffect;
